import { atomWithStorage, createJSONStorage } from 'jotai/utils';

/**
 * jotai atom 영구 저장 사용 시.
 */
export const atomPersist = <T>(key: string, initialValue: T) =>
  atomWithStorage<T>(key, initialValue, createJSONStorage(), { getOnInit: true });
